/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ceff90341a4542426bdaaa959fd3efdfbf7b7237";
